import {
  InfoCard,
  PatientInformation,
  ExtendedConsult,
  StorefrontHistory,
} from '../';
import { useTabDetailsInlineHeight as useInlineHeight } from '../../../hooks/useTabDetailsInlineHeight';
import {
  INFO_CARD_THEME, INTAKE, PATIENT, PRODUCT_INFO,
  TRUE, TAB_DETAILS_SCREEN_RESIZE_DELAY,
  PAGE_HEADING_SELECTOR,
  ORDER_HEADING_SELECTOR,
  EXTENDED_INFO_SELECTOR,
} from '../../../constants/patientChart.constant';
import { FEATURE } from '../../../utils/feature';

const hasFeature = FEATURE();

export const ExtendedInfo = ({
  orderId = 0,
  patientId = 0,
  doctorId = 0,
  patient = PATIENT(),
  productInfo = PRODUCT_INFO(),
  callingInfo = {},
  callSummaryReasons = {},
  messageTemplates = {},
  emailTemplates = {},
  emailTemplatesV2 = {},
  emailReasons = {},
  callPatientInfo = {},
  sendTextInfo = {},
  sendEmailInfo = {},
  orders = {},
  intake = INTAKE(),
  saveExtendedConsultInfo = {},
  icd10Codes = {},

  saveCallSummary = async () => {},
  callPatient = async () => {},
  getNotesTabInfo = () => {},
  sendText = async () => {},
  sendEmail = async () => {},
  getEmails = async (requestBody = {}) => {},
  saveExtendedConsult = async (requestBody = []) => {},
}) => {
  useInlineHeight({
    TRUE,
    delay: TAB_DETAILS_SCREEN_RESIZE_DELAY,
    selector: {
      targetElement: EXTENDED_INFO_SELECTOR,
    },
    totalNoOfGenericPaddings: 1,
    selectors: [
      PAGE_HEADING_SELECTOR,
      ORDER_HEADING_SELECTOR,
    ],
  });

  const PatientInformationComponent = new Map([
    [true, (
      <InfoCard
        heading='Patient Information'
        content={
          <PatientInformation
            orderId={orderId}
            patientId={patientId}
            doctorId={doctorId}
            patient={patient}
            product={productInfo}
            calling={callingInfo}
            callSummaryReasons={callSummaryReasons}
            messageTemplates={messageTemplates}
            emailTemplates={emailTemplates}
            emailTemplatesV2={emailTemplatesV2}
            emailReasons={emailReasons}
            callPatient={callPatient}
            saveCallSummary={saveCallSummary}
            callPatientInfo={callPatientInfo}
            getNotesTabInfo={getNotesTabInfo}
            hasActions
            sendText={sendText}
            sendTextInfo={sendTextInfo}
            sendEmail={sendEmail}
            sendEmailInfo={sendEmailInfo}
            getEmails={getEmails}
          />
        }
        bottomGutter
      />
    )],
    [false, <></>]
  ]);

  const ExtendedConsultComponent = new Map([
    [true, (
      <InfoCard
        heading='Extended Consult'
        content={
          <ExtendedConsult
            orderId={orderId}
            patientId={patientId}
            doctorId={doctorId}
            patient={patient}
            product={productInfo}
            orders={orders}
            intake={intake}
            hasActions
            saveExtendedConsult={saveExtendedConsult}
            saveExtendedConsultInfo={saveExtendedConsultInfo}
          />
        }
        bottomGutter
        theme={INFO_CARD_THEME.INFO}
      />
    )],
    [false, <></>]
  ]);

  const StorefrontHistoryComponent = new Map([
    [true, (
      <InfoCard
        heading='Storefront History'
        content={
          <StorefrontHistory
            orderId={orderId}
            patientId={patientId}
            doctorId={doctorId}
            patient={patient}
            product={productInfo}
            orders={orders}
            icd10Codes={icd10Codes}
            hasActions
          />
        }
        theme={INFO_CARD_THEME.INFO}
      />
    )],
    [false, <></>]
  ]);

  return (
    <div className='content-box top-negative-56 min-width-280 max-width-280 p-r-3 scroll-y-auto patient-chart-info-section-b-patient-info-column-a'>
      {PatientInformationComponent.get(hasFeature.PATIENT_INFORMATION)}
      {ExtendedConsultComponent.get(hasFeature.EXTENDED_CONSULT)}
      {StorefrontHistoryComponent.get(hasFeature.STOREFRONT_HISTORY)}
    </div>
  );
};

export default ExtendedInfo;
